export default __webpack_public_path__ + "911e81400110e9043a878e7882d5eb7a.gif";